import { Component, OnInit } from '@angular/core';
import { OrganizationManagerService } from '../../shared-api/organization/organization-manager.service';
import { Organization } from '../../shared-api/organization/organization.model';
import { BroadcastService } from '../../core/services/broadcast.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FolderManagerService } from '../../shared-api/folders/folder-manager.service';
import { Folder } from '../../shared-api/folders/folder.model';
import { PdfAsset } from '../../shared-api/pdfs/pdf-asset-model';

@Component({
    selector: 'myapp-doc-center',
    templateUrl: './doc-center.component.html',
    styleUrls: [ './doc-center.component.less' ]
})
export class DocCenterComponent implements OnInit
{
    loading = false;
    organization: Organization;
    folder: Folder;
    private allItems: (Folder | PdfAsset)[] = [];

    constructor(private broadcastService: BroadcastService,
                private folderManager: FolderManagerService,
                private orgManager: OrganizationManagerService,
                private route: ActivatedRoute,
                private router: Router) { }

    ngOnInit()
    {
        this.orgManager.currentOrganization.subscribe(org => this.organization = org);
        this.broadcastService.showHeader.next(true);
        this.route.params.subscribe(params =>
        {
            const folderId = params['id'] == null ? 0 : +params['id'];
            this.loadFolder(folderId);
        });

    }

    private loadFolder(id)
    {
        this.loading = true;
        this.folderManager.getFolder(id).subscribe(folder =>
        {
            this.folder = folder;
            this.allItems = [ ...folder.Folders, ...folder.Pdfs ];
            this.loading = false;
        });
    }

    isFolder(item: Folder[] | PdfAsset[]): boolean { return item instanceof Folder; }

    onFolderSelected(folder: Folder): void
    {
        this.router.navigate([ '/doc-center', folder.Id ]);
    }

    onPdfSelected(pdf: PdfAsset): void
    {
        window.open(pdf.Url);
    }
}
